webpackJsonp([212839066777427],{

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(26);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(34);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(33);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _objectWithoutProperties2 = __webpack_require__(63);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(62);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Handle legacy names for image queries.
	var convertProps = function convertProps(props) {
	  var convertedProps = (0, _extends3.default)({}, props);
	  if (convertedProps.responsiveResolution) {
	    convertedProps.resolutions = convertedProps.responsiveResolution;
	    delete convertedProps.responsiveResolution;
	  }
	  if (convertedProps.responsiveSizes) {
	    convertedProps.sizes = convertedProps.responsiveSizes;
	    delete convertedProps.responsiveSizes;
	  }
	
	  return convertedProps;
	};
	
	// Cache if we've seen an image before so we don't both with
	// lazy-loading & fading in on subsequent mounts.
	var imageCache = {};
	var inImageCache = function inImageCache(props) {
	  var convertedProps = convertProps(props);
	  // Find src
	  var src = convertedProps.sizes ? convertedProps.sizes.src : convertedProps.resolutions.src;
	
	  if (imageCache[src]) {
	    return true;
	  } else {
	    imageCache[src] = true;
	    return false;
	  }
	};
	
	var io = void 0;
	var listeners = [];
	
	function getIO() {
	  if (typeof io === "undefined" && typeof window !== "undefined" && window.IntersectionObserver) {
	    io = new window.IntersectionObserver(function (entries) {
	      entries.forEach(function (entry) {
	        listeners.forEach(function (l) {
	          if (l[0] === entry.target) {
	            // Edge doesn't currently support isIntersecting, so also test for an intersectionRatio > 0
	            if (entry.isIntersecting || entry.intersectionRatio > 0) {
	              io.unobserve(l[0]);
	              l[1]();
	            }
	          }
	        });
	      });
	    }, { rootMargin: "200px" });
	  }
	
	  return io;
	}
	
	var listenToIntersections = function listenToIntersections(el, cb) {
	  getIO().observe(el);
	  listeners.push([el, cb]);
	};
	
	var isWebpSupportedCache = null;
	var isWebpSupported = function isWebpSupported() {
	  if (isWebpSupportedCache !== null) {
	    return isWebpSupportedCache;
	  }
	
	  var elem = typeof window !== "undefined" ? window.document.createElement("canvas") : {};
	  if (elem.getContext && elem.getContext("2d")) {
	    isWebpSupportedCache = elem.toDataURL("image/webp").indexOf("data:image/webp") === 0;
	  } else {
	    isWebpSupportedCache = false;
	  }
	
	  return isWebpSupportedCache;
	};
	
	var noscriptImg = function noscriptImg(props) {
	  // Check if prop exists before adding each attribute to the string output below to prevent
	  // HTML validation issues caused by empty values like width="" and height=""
	  var src = props.src ? "src=\"" + props.src + "\" " : "src=\"\" "; // required attribute
	  var srcSet = props.srcSet ? "srcset=\"" + props.srcSet + "\" " : "";
	  var sizes = props.sizes ? "sizes=\"" + props.sizes + "\" " : "";
	  var title = props.title ? "title=\"" + props.title + "\" " : "";
	  var alt = props.alt ? "alt=\"" + props.alt + "\" " : "alt=\"\" "; // required attribute
	  var width = props.width ? "width=\"" + props.width + "\" " : "";
	  var height = props.height ? "height=\"" + props.height + "\" " : "";
	  var opacity = props.opacity ? props.opacity : "1";
	  var transitionDelay = props.transitionDelay ? props.transitionDelay : "0.5s";
	
	  return "<img " + width + height + src + srcSet + alt + title + sizes + "style=\"position:absolute;top:0;left:0;transition:opacity 0.5s;transition-delay:" + transitionDelay + ";opacity:" + opacity + ";width:100%;height:100%;object-fit:cover;object-position:center\"/>";
	};
	
	var Img = function Img(props) {
	  var style = props.style,
	      onLoad = props.onLoad,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ["style", "onLoad"]);
	
	  return _react2.default.createElement("img", (0, _extends3.default)({}, otherProps, {
	    onLoad: onLoad,
	    style: (0, _extends3.default)({
	      position: "absolute",
	      top: 0,
	      left: 0,
	      transition: "opacity 0.5s",
	      width: "100%",
	      height: "100%",
	      objectFit: "cover",
	      objectPosition: "center"
	    }, style)
	  }));
	};
	
	Img.propTypes = {
	  style: _propTypes2.default.object,
	  onLoad: _propTypes2.default.func
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3.default)(Image, _React$Component);
	
	  function Image(props) {
	    (0, _classCallCheck3.default)(this, Image);
	
	    // If this browser doesn't support the IntersectionObserver API
	    // we default to start downloading the image right away.
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	    var isVisible = true;
	    var imgLoaded = true;
	    var IOSupported = false;
	
	    // If this image has already been loaded before then we can assume it's
	    // already in the browser cache so it's cheap to just show directly.
	    var seenBefore = inImageCache(props);
	
	    if (!seenBefore && typeof window !== "undefined" && window.IntersectionObserver) {
	      isVisible = false;
	      imgLoaded = false;
	      IOSupported = true;
	    }
	
	    // Always don't render image while server rendering
	    if (typeof window === "undefined") {
	      isVisible = false;
	      imgLoaded = false;
	    }
	
	    _this.state = {
	      isVisible: isVisible,
	      imgLoaded: imgLoaded,
	      IOSupported: IOSupported
	    };
	
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  Image.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    if (this.state.IOSupported && ref) {
	      listenToIntersections(ref, function () {
	        _this2.setState({ isVisible: true, imgLoaded: false });
	      });
	    }
	  };
	
	  Image.prototype.render = function render() {
	    var _this3 = this;
	
	    var _convertProps = convertProps(this.props),
	        title = _convertProps.title,
	        alt = _convertProps.alt,
	        className = _convertProps.className,
	        outerWrapperClassName = _convertProps.outerWrapperClassName,
	        _convertProps$style = _convertProps.style,
	        style = _convertProps$style === undefined ? {} : _convertProps$style,
	        _convertProps$imgStyl = _convertProps.imgStyle,
	        imgStyle = _convertProps$imgStyl === undefined ? {} : _convertProps$imgStyl,
	        _convertProps$placeho = _convertProps.placeholderStyle,
	        placeholderStyle = _convertProps$placeho === undefined ? {} : _convertProps$placeho,
	        sizes = _convertProps.sizes,
	        resolutions = _convertProps.resolutions,
	        backgroundColor = _convertProps.backgroundColor,
	        Tag = _convertProps.Tag;
	
	    var bgColor = void 0;
	    if (typeof backgroundColor === "boolean") {
	      bgColor = "lightgray";
	    } else {
	      bgColor = backgroundColor;
	    }
	
	    var imagePlaceholderStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded ? 0 : 1,
	      transitionDelay: "0.25s"
	    }, imgStyle, placeholderStyle);
	
	    var imageStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0
	    }, imgStyle);
	
	    if (sizes) {
	      var image = sizes;
	
	      // Use webp by default if browser supports it
	      if (image.srcWebp && image.srcSetWebp && isWebpSupported()) {
	        image.src = image.srcWebp;
	        image.srcSet = image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: (0, _extends3.default)({
	              position: "relative",
	              overflow: "hidden"
	            }, style),
	            ref: this.handleRef
	          },
	          _react2.default.createElement(Tag, {
	            style: {
	              width: "100%",
	              paddingBottom: 100 / image.aspectRatio + "%"
	            }
	          }),
	          image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.base64,
	            style: imagePlaceholderStyle
	          }),
	          image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              position: "absolute",
	              top: 0,
	              bottom: 0,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.35s",
	              right: 0,
	              left: 0
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            srcSet: image.srcSet,
	            src: image.src,
	            sizes: image.sizes,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.state.IOSupported && _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({ alt: alt, title: title }, image))
	            }
	          })
	        )
	      );
	    }
	
	    if (resolutions) {
	      var _image = resolutions;
	      var divStyle = (0, _extends3.default)({
	        position: "relative",
	        overflow: "hidden",
	        display: "inline-block",
	        width: _image.width,
	        height: _image.height
	      }, style);
	
	      if (style.display === "inherit") {
	        delete divStyle.display;
	      }
	
	      // Use webp by default if browser supports it
	      if (_image.srcWebp && _image.srcSetWebp && isWebpSupported()) {
	        _image.src = _image.srcWebp;
	        _image.srcSet = _image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: divStyle,
	            ref: this.handleRef
	          },
	          _image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.base64,
	            style: imagePlaceholderStyle
	          }),
	          _image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              width: _image.width,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.25s",
	              height: _image.height
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            width: _image.width,
	            height: _image.height,
	            srcSet: _image.srcSet,
	            src: _image.src,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({
	                alt: alt,
	                title: title,
	                width: _image.width,
	                height: _image.height
	              }, _image))
	            }
	          })
	        )
	      );
	    }
	
	    return null;
	  };
	
	  return Image;
	}(_react2.default.Component);
	
	Image.defaultProps = {
	  fadeIn: true,
	  alt: "",
	  Tag: "div"
	};
	
	Image.propTypes = {
	  responsiveResolution: _propTypes2.default.object,
	  responsiveSizes: _propTypes2.default.object,
	  resolutions: _propTypes2.default.object,
	  sizes: _propTypes2.default.object,
	  fadeIn: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  alt: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]), // Support Glamor's css prop.
	  outerWrapperClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  style: _propTypes2.default.object,
	  imgStyle: _propTypes2.default.object,
	  placeholderStyle: _propTypes2.default.object,
	  position: _propTypes2.default.string,
	  backgroundColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	  onLoad: _propTypes2.default.func,
	  Tag: _propTypes2.default.string
	};
	
	exports.default = Image;

/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.media = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    @media (max-width: ', 'em) {\n      ', ';\n    }\n  '], ['\n    @media (max-width: ', 'em) {\n      ', ';\n    }\n  ']);
	
	var _styledComponents = __webpack_require__(12);
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; } /**
	                                                                                           * Code from https://github.com/stolinski/st2017/blob/master/src/components/Breakpoints.js
	                                                                                           */
	
	
	var sizes = {
	  giant: 1170,
	  desktop: 992,
	  tablet: 768,
	  phone: 376
	};
	
	var media = exports.media = Object.keys(sizes).reduce(function (accumulator, label) {
	  var emSize = sizes[label] / 16;
	  accumulator[label] = function () {
	    return (0, _styledComponents.css)(_templateObject, emSize, _styledComponents.css.apply(undefined, arguments));
	  };
	  return accumulator;
	}, {});

/***/ }),

/***/ 17:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var colors = exports.colors = {
	  darkTextColor: '#000',
	  lightTextColor: '#fff',
	  mediaColor: 'rgb(85, 26, 139)',
	  linkColor: '#0000EE',
	  bordersColor: '#ccc',
	  contentWrappersBackground: 'rgba(85, 26, 139, 0.05)',
	  mainContentWrapper: 'rgba(255, 255, 255, 1)',
	  gradientTop: '#3b10bb',
	  gradientBottom: '#1cefff',
	  blogItemHoverBG: 'rgba(72, 123, 49, 0.75)'
	};
	var maxMainWith = exports.maxMainWith = '1200px';
	var pageLinks = exports.pageLinks = [{
	  label: '',
	  link: '/',
	  gradientTop: '#053768',
	  gradientBottom: '#1cefff'
	}, {
	  label: '',
	  link: '/uses/',
	  gradientTop: '#b96417',
	  gradientBottom: '#ffcd7e'
	}, {
	  label: 'about',
	  link: '/about/',
	  gradientTop: '#b96417',
	  gradientBottom: '#ffcd7e'
	}, {
	  label: 'projects',
	  link: '/projects/',
	  gradientTop: '#4c0688',
	  gradientBottom: '#ed87f5'
	}, {
	  label: 'contact',
	  link: '/contact/',
	  gradientTop: '#b50c24',
	  gradientBottom: '#da7693'
	}, {
	  label: 'blog',
	  link: '/blog/',
	  gradientTop: '#487b31',
	  gradientBottom: '#bbf96d'
	}];

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  summary {\n    font-size: 1.2rem;\n  }\n  a,\n  a:link,\n  a:visited {\n    color: ', ';\n    text-decoration: none;\n  }\n  ul {\n    padding: 0;\n    li {\n      list-style: none;\n    }\n  }\n'], ['\n  summary {\n    font-size: 1.2rem;\n  }\n  a,\n  a:link,\n  a:visited {\n    color: ', ';\n    text-decoration: none;\n  }\n  ul {\n    padding: 0;\n    li {\n      list-style: none;\n    }\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: grid;\n  grid: auto / 200px 1fr;\n  grid-gap: 1rem;\n  align-content: center;\n  margin-bottom: 1rem;\n  border-radius: 3px;\n  padding: 5px;\n  &:hover {\n    transition: background-color 200ms linear;\n    color: ', ';\n    background: ', ';\n    .gatsby-image-wrapper {\n      opacity: 0.5;\n    }\n  }\n  ', ';\n  ', ';\n'], ['\n  display: grid;\n  grid: auto / 200px 1fr;\n  grid-gap: 1rem;\n  align-content: center;\n  margin-bottom: 1rem;\n  border-radius: 3px;\n  padding: 5px;\n  &:hover {\n    transition: background-color 200ms linear;\n    color: ', ';\n    background: ', ';\n    .gatsby-image-wrapper {\n      opacity: 0.5;\n    }\n  }\n  ', ';\n  ', ';\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n    grid: auto / 100px 1fr;\n    .gatsby-image-wrapper  {\n      width: 100px;\n      max-height: 100px;\n    }\n  '], ['\n    grid: auto / 100px 1fr;\n    .gatsby-image-wrapper  {\n      width: 100px;\n      max-height: 100px;\n    }\n  ']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n    grid: 100px 50px / auto;\n    justify-items: center;\n    .gatsby-image-wrapper  {\n      width: 100px;\n      max-height: 100px;\n    }\n  '], ['\n    grid: 100px 50px / auto;\n    justify-items: center;\n    .gatsby-image-wrapper  {\n      width: 100px;\n      max-height: 100px;\n    }\n  ']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  background-color: ', ';\n'], ['\n  background-color: ', ';\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  align-self: center;\n  align-content: center;\n'], ['\n  align-self: center;\n  align-content: center;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(31);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyImage = __webpack_require__(55);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _styledComponents = __webpack_require__(12);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactHelmet = __webpack_require__(20);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _constants = __webpack_require__(17);
	
	var _Breakpoints = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var BlogStyled = _styledComponents2.default.section(_templateObject, _constants.colors.darkTextColor);
	var BlogItemStyled = _styledComponents2.default.article(_templateObject2, _constants.colors.lightTextColor, _constants.colors.blogItemHoverBG, _Breakpoints.media.tablet(_templateObject3), _Breakpoints.media.phone(_templateObject4));
	var FeaturedImageStyled = _styledComponents2.default.div(_templateObject5, _constants.colors.lightTextColor);
	
	var BlogItemSummaryStyled = _styledComponents2.default.div(_templateObject6);
	var BlogPage = function BlogPage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    BlogStyled,
	    null,
	    _react2.default.createElement(_reactHelmet2.default, { title: 'Blog - Roberto V\xE1zquez Gonz\xE1lez Site' }),
	    _react2.default.createElement(
	      'h2',
	      { className: 'general__pageTitle' },
	      'Blog Posts'
	    ),
	    _react2.default.createElement(
	      'summary',
	      null,
	      'In this section you can find posts I occasionally create.'
	    ),
	    _react2.default.createElement(
	      'ul',
	      null,
	      data.allMarkdownRemark.edges.map(function (_ref2) {
	        var post = _ref2.node;
	        return _react2.default.createElement(
	          'li',
	          { key: post.id },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { key: post.id, to: post.frontmatter.path },
	            _react2.default.createElement(
	              BlogItemStyled,
	              null,
	              _react2.default.createElement(
	                FeaturedImageStyled,
	                null,
	                _react2.default.createElement(_gatsbyImage2.default, { sizes: post.frontmatter.featuredImage.childImageSharp.sizes })
	              ),
	              _react2.default.createElement(
	                BlogItemSummaryStyled,
	                null,
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  post.frontmatter.title
	                ),
	                _react2.default.createElement(
	                  'time',
	                  null,
	                  post.frontmatter.date
	                )
	              )
	            )
	          )
	        );
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      'Showing ',
	      data.allMarkdownRemark.edges.length,
	      ' of ',
	      data.allMarkdownRemark.totalCount
	    )
	  );
	};
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	
	exports.default = BlogPage;
	/**
	 * Prop types
	 */
	
	BlogPage.propTypes = {
	  data: _propTypes2.default.object
	};
	
	BlogPage.defaultProps = {
	  data: {}
	};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-blog-js-aed9112c3e48dd18c005.js